import { useForm } from "react-hook-form";
import {
  CityPayloadSchema,
  cityPayloadSchema,
  useCityCreate,
} from "@/api/city";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import { CityFormFields } from "./CityFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { ErrorMessageFromResponse } from "@/api/types";

export function CityCreateForm() {
  const form = useForm<CityPayloadSchema>({
    resolver: zodResolver(cityPayloadSchema),
  });
  const { mutate, isPending } = useCityCreate();
  const navigate = useNavigate();

  function handleSubmit(values: CityPayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "City has been created",
            })
            .then(() => navigate("/master-data/city"));
        },
        onError: (error) => {
          swalError.fire({
            text:
              (error as ErrorMessageFromResponse).response?.data.data ??
              error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <CityFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/city" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
